import type { FC } from "react";

import type { ExtensivePromotion } from "~/core/deprecated/extensive-promotions";
import { Text } from "~/shared/ui-kit";
import { Title } from "~/shared/ui-kit/title/Title";

type PromoDescriptionType = {
  data: ExtensivePromotion;
  lang: LanguageCode;
  alignment?: "center" | "start";
  reverse?: boolean;
};
export const PromoDescription: FC<PromoDescriptionType> = ({
  data,
  lang,
  alignment = "start",
  reverse,
}) => {
  return (
    <div
      className={`flex flex-col justify-center ${reverse ? "lg:flex-row-reverse" : "lg:flex-row"} ${alignment === "center" ? "md:items-center" : "md:items-start"} py-6 md:py-16 px-4 xl:px-0 md:gap-4 xl:gap-10 max-w-[1240px]  mx-auto`}
    >
      <div className="mb-6 md:py-0 text-white lg:w-1/2 ">
        <Title
          as="h3"
          size="medium"
          weight="bold"
          className="mb-6 whitespace-pre-line"
        >
          {data.title[lang]}
        </Title>
        <Text content={data.description[lang]} size="small" className="mb-4" />
      </div>
      <picture className="flex justify-center">
        <source
          media="(min-width: 1024px)"
          srcSet={data.imageDesktop[lang]}
          className="max-w-[600px]"
        />
        <source
          media="(max-width: 800px)"
          srcSet={data.imageMobile[lang]}
          className="max-w-full"
        />
        <img
          alt={data.title[lang]}
          src={data.imageDesktop[lang]}
          className="mx-auto max-w-full md:max-w-[600px] rounded-lg"
        />
      </picture>
    </div>
  );
};
